import PropTypes from 'prop-types'
import React from 'react'
import SwitchField from '../../molecules/fields/SwitchField'

const SwitchOtherForm = ({ onEnabled }) => {
  return <SwitchField name="other_forms_enabled" parentClassName="mt-1 md:mt-0" onChange={onEnabled} />
}

export default SwitchOtherForm

SwitchOtherForm.propTypes = {
  onEnabled: PropTypes.func
}
